import type { ComponentProps } from 'react';

import VerificationSupportingInformation from '@/features/verification/components/supporting-information';
import VerificationLayout from '@/features/verification/layout';

interface VerificationSupportingInformationPageProps extends ComponentProps<typeof VerificationSupportingInformation> {
  layoutProps?: ComponentProps<typeof VerificationLayout>;
}

const VerificationSupportingInformationPage = ({ layoutProps, ...props }: VerificationSupportingInformationPageProps) => {
  return (
    <VerificationLayout {...layoutProps}>
      <VerificationSupportingInformation {...props} />
    </VerificationLayout>
  );
};
VerificationSupportingInformationPage.displayName = 'VerificationSupportingInformationPage';

export default VerificationSupportingInformationPage;
